import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledModalContent = styled(FlexColumn)`
    margin-top: -4px;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    gap: 16px;
    overflow: visible;
`;

export const StyledInputModeFrame = styled(FlexColumn)`
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    gap: 16px;
    padding: 16px;
    border-radius: 6px;
    background-color: ${colorsPalettes.bluegrey[200]};
`;

export const StyledModalChipsSection = styled(FlexColumn)`
    width: 100%;
    min-width: 0;
    min-height: 40px;
    gap: 12px;
`;

export const StyledSegmentedControlContainer = styled(Flex)`
    width: 100%;
    min-width: 0;
`;

export const StyledBulkInputSection = styled(Stack)`
    position: relative;
    flex: 1 1 0;
    min-width: 0;
    width: 100%;
    box-sizing: border-box;
    overflow: visible;
`;

export const StyledSiteTagsBulkValidationFailed = styled.p`
    ${setFontVariant("body2", colorsPalettes.red[400])}
    margin: 0;
`;

export const StyledBulkModeBannersSection = styled(FlexColumn)`
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    gap: 12px;
`;

export const StyledValuesFieldContainer = styled.div`
    flex: 1 1 0;
    min-width: 0;
    width: 100%;
    box-sizing: border-box;
    overflow: visible;

    & > * {
        width: 100%;
        box-sizing: border-box;
    }

    & :has(> .DropdownButton) {
        flex: 1 1 0;
        width: 100%;
    }

    & .DropdownButton {
        width: 100%;
        box-sizing: border-box;
    }
`;
